export default{
  variant: (state) => state.variant
}



// WEBPACK FOOTER //
// ./src/components/preview/store/getters.js